import { versionApi } from 'lib/api';
import { useInterval } from 'lib/hooks/useInterval';
import React, { createContext, ReactNode, useState } from 'react';

interface VersionContextValue {
  currentVersion: string | null;
  isNewVersionAvailable: boolean;
  setIsNewVersionAvailable: (isNewVersionAvailable: boolean) => void;
}

export const VersionContext = createContext<VersionContextValue>({
  currentVersion: null,
  isNewVersionAvailable: false,
  setIsNewVersionAvailable: () => {},
});

interface VersionProviderProps {
  children: ReactNode;
  initialVersion: string;
  intervalInMS: number | null;
}

export const VersionProvider: React.FC<VersionProviderProps> = ({
  children,
  initialVersion,
  intervalInMS,
}) => {
  const [currentVersion] = useState(initialVersion);
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);

  const fetchLatestVersion = async () => {
    try {
      const response = await versionApi.request({
        method: 'get',
      });

      if (response.status !== 200) throw new Error('Error fetching version');
      const version = response.data.sha;

      setIsNewVersionAvailable(version !== currentVersion);
    } catch (err) {
      console.error('Error fetching latest version:', err);
    }
  };

  useInterval(fetchLatestVersion, intervalInMS);

  return (
    <VersionContext.Provider
      value={{
        currentVersion,
        isNewVersionAvailable,
        setIsNewVersionAvailable,
      }}
    >
      {children}
    </VersionContext.Provider>
  );
};
